import React from 'react';
import wb0 from '../img/Detail/samsung-detail.jpg';
import './Detail.css';
const SamsungDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default SamsungDetail;